export const ignoreKeys = [
  'dashMode',
  'showDash',
  'dashLayout',
  'dashGridSize',
  'selectedControlMenu',
  'showDataViewerBottom',
  'selectedTileId',
  'selectedTileName',
  'tabId',
  'previousTabId',
  'previousTileId',
  'chartOptionSelected',
  'chartData',
  'serverData',
  'dashboardHeight',
  'selectedOption',
  'hoveredPropkey',
  'hoveredItems',
  'hoveredTileKey',
  'selectedTileKey',
  'isCollapsed',
  'tvSettings',
  'callQueryAPI',
  'callQueryAPIDashboard',
];
